// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AdminShiftFormController from "./admin_shift_form_controller"
application.register("admin-shift-form", AdminShiftFormController)

import AssignmentsController from "./assignments_controller"
application.register("assignments", AssignmentsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MainController from "./main_controller"
application.register("main", MainController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import ServiceWorkerController from "./service_worker_controller"
application.register("service-worker", ServiceWorkerController)

import ShiftsIndexController from "./shifts_index_controller"
application.register("shifts-index", ShiftsIndexController)
